import isEmpty from 'lodash/isEmpty';

const isProductInactive = ({ product }) => !isEmpty(product) && product.isActive === 'N';

const main = {
  title: ({ product, product: { brand, productName } }) => {
    if (isProductInactive(product)) {
      return `Buy ${brand} ${productName} now at italist and save up to 30%. EXPRESS international shipping! Similar products also available.`;
    }

    return 'Shop italist | Curated luxury fashion at the best price';
  },
  description: () =>
    'Over 200,000 international fashion products, up to 30% cheaper, express shipped from the best Italian stores. Shop 1,000 worldwide luxury brands',
};

export default main;
